<template>
  <div id="app">
    <!-- 公用页面顶部组件 -->
    <PageHeader />
    <!-- <transition
      name="custom-classes-transition"
      enter-active-class="animate__animated animate__bounceInRight"
    > -->
    <router-view />
    <!-- </transition> -->
  </div>
</template>

<style lang="scss"></style>
<script>
import PageHeader from "@/components/PageHeader";
export default {
  components: { PageHeader },
  data: function () {
    return {};
  },
  mounted() {
    // // 初始化设置渠道二维码扫码 未记录
    // if (!sessionStorage.getItem("onlyScanRecorded")) {
    //   sessionStorage.setItem("onlyScanRecorded", false);
    // }
  },
};
</script>
// enter-active-class="animate__animated animate__bounceInRight"
